export type GalleryCategory = "all" | "normal" | "sensitive";

export const galleryCategories: { key: GalleryCategory; label: string; restricted: boolean }[] = [
  { key: "all", label: "すべて", restricted: false },
  { key: "normal", label: "ノーマル", restricted: false },
  { key: "sensitive", label: "センシティブ", restricted: true },
];

export const galleryImages = [
  // ノーマル（普段着・私服）
  {
    id: 36,
    category: "normal" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/17179e02-51fc-4d65-beb3-8af738447642_G24.png?v=f83270eb8ea132d4a641ea20788786d4",
    alt: "Normal Photo G24",
    width: 600,
    height: 900,
  },
  {
    id: 63,
    category: "normal" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/254f5ddb-151b-4d95-847f-3012e2384f72_G57.png?v=54a19980d0c83e320470bd7cef0788c1",
    alt: "Normal Photo G57",
    width: 600,
    height: 900,
  },
  {
    id: 53,
    category: "normal" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/4530b9f0-bd23-4d30-9ce9-5d4b13eb675a_G42.png?v=9f14f24edbfc5ca47ebf47c30386dc64",
    alt: "Normal Photo G42",
    width: 600,
    height: 900,
  },
  {
    id: 69,
    category: "normal" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/7e9cf2c1-28fd-496e-9c68-098cd773de58_G54.png?v=2e4ff725dbc26bc8cb80ffbc98992fa6",
    alt: "Normal Photo G54",
    width: 600,
    height: 900,
  },
  {
    id: 60,
    category: "normal" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/403432f0-3565-46cb-b722-5295bbb8a9aa_G48.png?v=c5798a4ea15b37c5ff5bee146bf494e1",
    alt: "Normal Photo G48",
    width: 600,
    height: 900,
  },
  {
    id: 61,
    category: "normal" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/040f5cf8-2349-40b3-abfd-12af8f11ab34_G49.png?v=585181d0f37a62acad3ffce43695e30c",
    alt: "Normal Photo G49",
    width: 600,
    height: 900,
  },
  {
    id: 64,
    category: "normal" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/fe8e992c-344c-40d2-bae4-8e0e7865fb7d_G58.png?v=cee84c72982d8300188b018810b29db9",
    alt: "Normal Photo G58",
    width: 600,
    height: 900,
  },
  {
    id: 65,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/ce8779bf-0048-4893-8a67-82fad12c37a2_G59.png?v=764bd7b14352ea12f899ab11132a3299",
    alt: "Sensitive Photo G59",
    width: 600,
    height: 900,
  },
  {
    id: 66,
    category: "normal" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/aa23da4c-f105-49f0-9a66-92c2bff25656_G60.png?v=9ee1c53599dac8296ec83f15c9644ba1",
    alt: "Normal Photo G60",
    width: 600,
    height: 900,
  },
  // センシティブ（ランジェリー・セクシー系）
  {
    id: 62,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/5a834a29-d395-4dc2-9b34-eba5d89bfd30_G51.png?v=05bae27cee59aabfa8a99e796850fe5b",
    alt: "Sensitive Photo G51",
    width: 600,
    height: 900,
  },
  {
    id: 48,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/0e580e5e-4c75-4358-9c46-c3dd6b6e5025_G36.png?v=4ec5aef2bdd25cb929399097a4a86f92",
    alt: "Sensitive Photo 40",
    width: 600,
    height: 900,
  },
  {
    id: 72,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/05eca98e-e1a4-4a8f-82fd-b5772d185657_8F4454F5-816D-4EBF-8702-DCC51D41CFD2.jpg?v=7ec0d0a325d9de496864ac6cdea07f39",
    alt: "Sensitive Photo G72",
    width: 600,
    height: 900,
  },
  {
    id: 22,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/14f315a8-ff84-400b-ba3c-44ee9f2ff754_G10.png?v=cca7c1eaca6846be2200cbf2e26b63b3",
    alt: "Sensitive Photo 14",
    width: 600,
    height: 900,
  },
  {
    id: 9,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/0b18a622-3098-4f33-8c0c-984544dbe1d1_G.png?v=52b976c5a2fc573a8559050d74383216",
    alt: "Sensitive Photo 1",
    width: 600,
    height: 900,
  },
  {
    id: 13,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/96b7720d-51c3-4bf6-83fb-cbe4795838fa_G2.png?v=5e1ffe32bb3151e0b3d579fce38defa1",
    alt: "Sensitive Photo 5",
    width: 600,
    height: 1000,
  },
  {
    id: 15,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/d25aa4db-c5e7-4d89-b85c-5c7d9681dcb7_G3.png?v=d6a6c5dd5f02277f5739a7f5e9cfff10",
    alt: "Sensitive Photo 7",
    width: 600,
    height: 900,
  },
  {
    id: 17,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/a2918f15-9a11-405f-b232-50549bd03fa8_G5.png?v=8cc6e599656ee36948e9f6acdc0099d6",
    alt: "Sensitive Photo 9",
    width: 600,
    height: 900,
  },
  {
    id: 18,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/9df6c1ed-be50-49fd-9d53-705a3188e3ae_G6.png?v=ba8f0281cb0ead68703a1d3cf14fc9aa",
    alt: "Sensitive Photo 10",
    width: 600,
    height: 900,
  },
  {
    id: 21,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/069f5eee-8bdf-4fd6-ae5c-091a5be99abb_G9.png?v=fd06e80bb565f84234dd20ee0870ae4c",
    alt: "Sensitive Photo 13",
    width: 600,
    height: 900,
  },
  {
    id: 34,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/970f71e2-1fab-49b7-a98f-58ac07b800fb_G22.png?v=da2aa1d49680acf454d3857063716209",
    alt: "Sensitive Photo 26",
    width: 600,
    height: 900,
  },
  {
    id: 24,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/96db016b-9950-4983-a7a2-5ffd7f4e6648_G12.png?v=78ba8f78ea5ed6e91a6cf9fc24c8e9af",
    alt: "Sensitive Photo 16",
    width: 600,
    height: 900,
  },
  {
    id: 25,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/2f110250-dd2e-4005-be72-e9f718e8cd19_G13.png?v=e0c9fdc8b349a37b4216dc31481e5f63",
    alt: "Sensitive Photo 17",
    width: 600,
    height: 900,
  },
  {
    id: 26,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/e1848b0c-915f-47f8-8b8b-58b4b9ee985f_G14.png?v=81df99ff8f0b5cb9ed23f1acdcaef924",
    alt: "Sensitive Photo 18",
    width: 600,
    height: 900,
  },
  {
    id: 27,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/61ad66ec-b5a1-447e-9aa8-e2468d9c8f21_G15.png?v=1965c6d59009d696fa20e59439f65e37",
    alt: "Sensitive Photo 19",
    width: 600,
    height: 900,
  },
  {
    id: 28,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/0edc42b2-4afd-4578-ab5e-ebe790afe8d9_G16.png?v=ac60b0e125152a079658f04d0f100ced",
    alt: "Sensitive Photo 20",
    width: 600,
    height: 900,
  },
  {
    id: 29,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/028f3b98-4cd0-4d5e-b9a6-126927814d0b_G17.png?v=728ff585b73a6bd395eb2cbeae520622",
    alt: "Sensitive Photo 21",
    width: 600,
    height: 900,
  },
  {
    id: 30,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/354e002b-bc48-4e18-b4f8-26ad0bc85c96_G18.png?v=e2a62e382c184def0fbf893c51fae3a1",
    alt: "Sensitive Photo 22",
    width: 600,
    height: 900,
  },
  {
    id: 31,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/8eb2b6e5-6a59-4cc2-85df-291d636be31e_G19.png?v=44ca2968dd4db7b71b2deb1b06b53361",
    alt: "Sensitive Photo 23",
    width: 600,
    height: 900,
  },
  {
    id: 32,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/ff0fe035-8586-4eec-bdbb-bd9750c71d56_G20.png?v=1ea87172fed9c0861fee9109ef3a61b5",
    alt: "Sensitive Photo 24",
    width: 600,
    height: 900,
  },
  {
    id: 33,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/30231404-3b50-4d61-a781-3365b4dbb665_G21.png?v=25e2bdd311b926403596e82c5b1ecb3c",
    alt: "Sensitive Photo 25",
    width: 600,
    height: 900,
  },
  {
    id: 38,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/7d7b95ab-1c8a-499c-8d17-0800bb6e652e_G26.png?v=7f2a58193cf09c462626d366347c4008",
    alt: "Sensitive Photo 30",
    width: 600,
    height: 900,
  },
  {
    id: 40,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/bc40353c-34f0-4654-847b-9cf20155ff00_G28.png?v=816a8ae46f50066496b83cdcc7bf0b9d",
    alt: "Sensitive Photo 32",
    width: 600,
    height: 900,
  },
  {
    id: 41,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/77314b62-3705-45a8-b471-adbcf1806caf_G29.png?v=3bfef8bb13d3b80e56935c713de3fc83",
    alt: "Sensitive Photo 33",
    width: 600,
    height: 900,
  },
  {
    id: 42,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/99405afe-c93f-48f3-b748-e5de62f9ca51_G30.png?v=98fca86e976c618db3186d920cd3a3d1",
    alt: "Sensitive Photo 34",
    width: 600,
    height: 900,
  },
  {
    id: 43,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/10dc16bb-d479-4378-a8be-aac3b9b5e9eb_G31.png?v=8129a5d6642eb85d1d268b402ab09ecb",
    alt: "Sensitive Photo 35",
    width: 600,
    height: 900,
  },
  {
    id: 44,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/459ec8d6-6925-41b6-b4ee-20e2c814ffc3_G32.png?v=f48c9fd6a4d6d29cdc89897e948f2d65",
    alt: "Sensitive Photo 36",
    width: 600,
    height: 900,
  },
  {
    id: 45,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/96f6d445-122c-45e8-8cd0-a26356dc78d4_G33.png?v=9ff00648546bfae6553d04eab12464fb",
    alt: "Sensitive Photo 37",
    width: 600,
    height: 900,
  },
  {
    id: 46,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/d98fbeab-dafd-4830-81c8-6e4aa36a4da7_G34.png?v=32c06e4385fe33386ac0c5297a79ebe8",
    alt: "Sensitive Photo 38",
    width: 600,
    height: 900,
  },
  {
    id: 47,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/fa7062c8-38ce-4ee9-921d-c99f0d24cfec_G35.png?v=5b3f04a671e0947bc83a8d889f54b063",
    alt: "Sensitive Photo 39",
    width: 600,
    height: 900,
  },
  {
    id: 49,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/dab65411-55e0-494e-9202-4fb1ef531c41_G37.png?v=b4b997ea03137b7802406387d526dd18",
    alt: "Sensitive Photo 41",
    width: 600,
    height: 900,
  },
  {
    id: 50,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/eb6550aa-a4be-4a56-a42a-8a4509f5cee3_G39.png?v=b3453898062e7c23537e661958bc337b",
    alt: "Sensitive Photo 42",
    width: 600,
    height: 900,
  },
  {
    id: 51,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/f8b99dc3-0a60-49b6-837f-8613a888c756_G40.png?v=5ef5907e946bf71e5de29778ad539091",
    alt: "Sensitive Photo 43",
    width: 600,
    height: 900,
  },
  {
    id: 52,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/27babb54-23ec-47dc-89c2-2df4c489c308_G41.png?v=95fc99192225b9089db990b0877b1610",
    alt: "Sensitive Photo 44",
    width: 600,
    height: 900,
  },
  {
    id: 54,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/b9f1a845-795b-4fc9-acb7-10b41872ce71_G43.png?v=630eadaf133132b2265794d84f12e5ff",
    alt: "Sensitive Photo 46",
    width: 600,
    height: 900,
  },
  {
    id: 55,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/bd60c02e-15d0-4f31-9df2-301ce7235e55_G44.png?v=087d04c3a05d47725b55231fab6313e1",
    alt: "Sensitive Photo 47",
    width: 600,
    height: 900,
  },
  {
    id: 56,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/db009166-8b29-4f7b-adc2-fde9f9f5ee4c_G45.png?v=dc8339ddaa0bafd81686ebcb5183139a",
    alt: "Sensitive Photo 48",
    width: 600,
    height: 900,
  },
  {
    id: 57,
    category: "normal" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/f1ea1ced-4d7a-4625-9e20-5a057ed6f5a3_G46.png?v=e6747347dd9ba33862b8718ea1ab360d",
    alt: "Normal Photo G46",
    width: 600,
    height: 900,
  },
  {
    id: 67,
    category: "normal" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/9ba85a71-8b90-4948-8c9d-de3fc0e64413_G52.png?v=4133ba4c3ce755f5a5642fd5ac02503a",
    alt: "Normal Photo G52",
    width: 600,
    height: 900,
  },
  {
    id: 68,
    category: "normal" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/c9bac195-ef42-4009-bc0d-5cef5d087a04_G53.png?v=32757ba5cbb9314b31cfb435a37e4259",
    alt: "Normal Photo G53",
    width: 600,
    height: 900,
  },
  {
    id: 71,
    category: "normal" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/da25d424-f757-42d5-b7f3-76aac1c0ee3b_G56.png?v=249d9b0d36cf42f836cc65d72af9236d",
    alt: "Normal Photo G56",
    width: 600,
    height: 900,
  },
  {
    id: 35,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/71f5bfd3-c20e-4e06-a9ae-40040a3f0736_G23.png?v=8687ba7020d63f366a9d60142c799d49",
    alt: "Sensitive Photo 27",
    width: 600,
    height: 900,
  },
  {
    id: 59,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/ab11a70f-3d43-4ba0-8011-36a891139d35_G47.png?v=82ccff6a9a5e961a490ed0da70d4b12f",
    alt: "Sensitive Photo G47",
    width: 600,
    height: 900,
  },
  {
    id: 58,
    category: "sensitive" as GalleryCategory,
    src: "https://storage.readdy-site.link/project_files/5fc4a5c0-7993-4a64-a378-6d67b6cf5ae0/26ceef1e-43c1-4f56-8dad-c322e0ecca1e_G50.png?v=55980dad9ab3955bd575711dbdf16b99",
    alt: "Sensitive Photo 50",
    width: 600,
    height: 900,
  },
];
